import React from 'react';
import { Autocomplete, TextField, Tooltip } from '@mui/material';
import { RemoveCircleOutline, InfoOutlined } from "@mui/icons-material";
import muiInputStyles from '../MuiInput/MuiInputStyles';

const InterpreterAutocomplete = ({
  index,
  value,
  inputValue,
  options,
  disabled = false,
  label,
  onSelectionChange,
  onInputChange,
  onRemove,
  error,
  showRemoveButton = true,
  removeDisabled = false,
  showCompletedIcon = false,
  ariaLabel,
}) => {
  const classes = muiInputStyles();

  const handleChange = (event, newValue) => {
    if (newValue && newValue.email) {
      onSelectionChange(index, newValue);
    } else {
      onInputChange(index, "");
    }
  };

  const handleInputChange = (event, newInputValue) => {
    onInputChange(index, newInputValue);
  };

  const handleRemove = () => {
    if (onRemove) {
      onRemove(index);
    }
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", marginBottom: '1.5rem' }}>
        <Autocomplete 
          fullWidth
          size="small"
          id={`interpreter_${index + 1}`}
          className={classes.muiInputs}
          options={options}
          getOptionLabel={(option) => option.fullName || ""}
          value={value}
          inputValue={inputValue}
          onChange={handleChange}
          onInputChange={handleInputChange}
          filterOptions={(options, { inputValue }) => 
            options.filter(option => 
              option.fullName.toLowerCase().includes(inputValue.toLowerCase())
            )
          }
          popperprops={{
            modifiers: [
              { name: 'flip', enabled: false }, // prevent it from flipping to top
            ],
            placement: 'bottom-start', // optional, MUI usually uses this by default
          }}
          freeSolo
          disabled={disabled}
          renderInput={(params) => (
            <TextField 
              aria-label={ariaLabel || `interpreter_${index + 1}_input`}
              className={classes.muiInputs}
              {...params}
              label={label}
              variant="outlined"
              sx={{
                
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'var(--alt-black)',
                  opacity: 1, 
                  cursor: 'not-allowed',
                },
              }}
              InputProps={{
                ...params.InputProps,
                readOnly: disabled,
                style: {
                  backgroundColor: disabled ? "#e9ecef" : "#fff",
                  cursor: disabled ? "not-allowed" : "pointer"
                },
                endAdornment: (
                  <>
                    {params.InputProps.endAdornment}
                    {showCompletedIcon && (
                      <Tooltip
                        title="This interpreter has completed an interpretation and cannot be removed"
                        placement="top"
                        arrow
                        componentsProps={{ tooltip: { sx: { fontSize: '14px' } } }}
                      >
                        <span
                          tabIndex={0}
                          role="img"
                          aria-label="This interpreter has completed an interpretation and cannot be removed"
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <InfoOutlined
                            style={{
                              fontSize: '1.1rem',
                              color: 'var(--info-color)',
                              filter: 'brightness(0.90)',
                              cursor: 'pointer',
                              pointerEvents: 'auto',
                              marginRight: '4px',
                            }}
                          />
                        </span>
                      </Tooltip>
                    )}
                  </>
                ),
              }}
            />
          )}
          disablePortal={false}
        />
        {showRemoveButton && (
          <button
            onClick={handleRemove}
            className="addRemoveButton"
            style={{ marginLeft: '10px' }}
            type="button"
            disabled={removeDisabled}
          >
            <span className="addRemoveButtonSpan">
              <RemoveCircleOutline className="addRemoveIcons" alt="remove" fontSize="small" />
            </span>
            <span>Remove</span>
          </button>
        )}
      </div>
      {error && (
        <div className="combobox-error" style={{ color: 'var(--error-color)', fontSize: '0.9em' }}>
          {error}
        </div>
      )}
    </>
  );
};

export default InterpreterAutocomplete;
